import React from "react";
import {UserMenuItemBox} from "./boxes/user-menu-item.box";
import {UserMenuItemsTitleBox} from "./boxes/user-menu-items-title.box";
import {MenuItemComponentProps} from "../../../services/menu-items-common/menu-item-component-props.interface";
import {observer} from "mobx-react";
import {UserMenuSectionBox} from "../user-menu/boxes/user-menu-section.box";


export const UserMenuItemComponent: React.FC<MenuItemComponentProps> = observer((props) =>  {
    return (
        <UserMenuSectionBox onClick={() => props.menuItem.execute()}>
            <UserMenuItemBox>
                <UserMenuItemsTitleBox>
                    {props.menuItem.text}
                </UserMenuItemsTitleBox>
            </UserMenuItemBox>
        </UserMenuSectionBox>
    )
});
